export const onClaimSuccessJobOptions = {
    delay: 100,
    attempts: 3,
    backoff: {
        type: 'exponential',
        delay: 250,
    },
};
